import { config, gameState } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: "StartScene",
    });
  }

  preload() {
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    //audio
    config.audio.bgaudio = this.sound.add("bgaudio");

    this.add.sprite(config.width / 2, config.height / 2, "mainBG").setScale(1);
    this.parachute1 = this.add.sprite(350, 600, "parachute").setScale(1.5);
    this.parachute2 = this.add.sprite(1000, 300, "parachute");

    this.add.sprite(300, 100, "cloudLeft");

    this.cartWheelStand = this.add
      .sprite(config.width / 2 + 300, config.height / 2 + 200, "cartWheelStand")
      .setAlpha(0.4)
      .setScale(0.8);
    this.cartWheel = this.add
      .sprite(config.width / 2 + 300, config.height / 2 + 88, "cartWheel")
      .setAlpha(0.4)
      .setScale(0.8);

    // this.cloudRight = this.add.sprite(1350, 250, "cloudRight").setScale(0.8);

    this.add.sprite(402, 298, "gameName").setOrigin(0);

    this.add.sprite(config.width / 2, config.height / 2 + 120, "ground");

    this.playButton = this.add.sprite(config.width / 2, config.height / 2 + 110, "playButton").setInteractive({
      cursor: "pointer",
    });

    this.playButton.on(
      "pointerover",
      function (pointer) {
        //this.playButton.setTint(0xc4c4c4);
        this.playButton.setTexture("playHover");
      },
      this
    );
    this.playButton.on(
      "pointerout",
      function (pointer) {
        //this.playButton.setTint();
        this.playButton.setTexture("playButton");
      },
      this
    );

    this.playButton.on(
      "pointerdown",
      () => {
        enablePointerEvents();
        this.playButton.setScale(0.8);
        this.playButton.setTint();
        config.audio.bgaudio.setLoop(true).setVolume(0.01).play();

        this.cameras.main.fadeOut(500, 255, 255, 255);

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            this.scene.stop("StartScene");
            this.scene.start("TutorialScene");
            //this.scene.start("GameScene");
          },
          this
        );
      },
      this
    );

    this.playButton.on(
      "pointerup",
      function (pointer) {
        this.playButton.disableInteractive();
        this.playButton.setScale(1);
      },
      this
    );
  }

  update() {
    this.cartWheel.rotation += 0.003;

    // if (this.cloudRight.x > -200) {
    //   this.cloudRight.x -= 0.2;
    // } else {
    //   this.cloudRight.x = 1200;
    // }

    this.parachute1.y -= 0.5;
    this.parachute2.y -= 0.5;
    if (this.parachute1.y < -60) {
      this.parachute1.y = 700;
    }
    if (this.parachute2.y < -60) {
      this.parachute2.y = 700;
    }
  }
}
